import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Contract, ContractService, SupplyMode, Material } from "../../../contracts/services/contract.service"
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { Router } from "@angular/router";
import { NotificationService } from "../../../common/component/notification/notification.service"

@Component({
  selector: 'app-contractlist',
  templateUrl: './contractlist.component.html',
  styleUrls: ['./contractlist.component.scss']
})
export class ContractlistComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  readonly allowedPageSizes = [50,100,200];

  materials: Material[];
  awardYears: string[];
  supplyModes: string[];
  supplyModeList: any;
  suppliers: any[];
  updatedContract: Contract;
  public filteredContractsList: Contract[];
  customerName: string;
  materialName: string;
  supplierName: string;
  supplyModeName: string;
  awardYearFrom: string;
  awardYearTo: string;
  commenceYearFrom: string;
  commenceYearTo: string;
  isLoadPanelVisible: boolean = false
  saleAmountHeaderFilter: any;
  applyFilterTypes: any;
  editRowKey?: number = null;
  currentFilter: any;

  showFilterRow: boolean;

  showHeaderFilter: boolean;

  constructor(private contractService: ContractService,
    private router: Router,
    private notificationService: NotificationService) {
    this.awardYears = contractService.getAwardYears();
    this.supplyModes = contractService.getSupplyModes();
    this.updatedContract = new Contract();
    this.customerName = '';
    this.materialName = '';
    this.supplierName = '';
    this.supplyModeName = '';
    this.awardYearFrom = '';
    this.awardYearTo = '';
    this.commenceYearFrom = '';
    this.commenceYearTo = '';
        this.showFilterRow = true;
    this.showHeaderFilter = true;
  }

  ngOnInit(): void {
    this.isLoadPanelVisible = true;
    this.getMaterials();
    this.getSuppliers();
    this.loadContracts();
  }

  loadContracts() {
    try {
      this.contractService.getContracts().subscribe(data => {
      if (data) {
          this.filteredContractsList = data;
          this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the contract information", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      alert((e as Error).message);
    }
  }

  exportPdf() {
    const doc = new jsPDF('landscape');
    exportDataGridToPdf({
      jsPDFDocument: doc,
      component: this.dataGrid.instance,
    }).then(() => {
      doc.save('Contracts.pdf');
    });
  }

  exportExcel(e) {
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
        component: this.dataGrid.instance,
        worksheet: worksheet
    }).then(function() {
        workbook.xlsx.writeBuffer()
            .then(function(buffer: BlobPart) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Contracts.xlsx');
            });
    });
    e.cancel = true; 
}

  resetFilters() {
    this.dataGrid.instance.clearFilter();
  }

  onRowDoubleClick(e) {
    this.router.navigate([`/update-contract/${e.key}`]);
  }

  onSaving(e) {
    this.isLoadPanelVisible = true;
    this.updatedContract.supplier = e.newData.supplier ?? e.oldData.supplier;
    this.updatedContract.material = e.newData.material ?? e.oldData.material;
    this.updatedContract.customer = e.newData.customer ?? e.oldData.customer;
    this.updatedContract.quantity = e.newData.quantity ?? e.oldData.quantity;
    this.updatedContract.quantityUom = e.newData.quantityUom ?? e.oldData.quantityUom;
    this.updatedContract.price = e.newData.price ?? e.oldData.price;
    this.updatedContract.pricingUom = e.newData.pricingUom ?? e.oldData.pricingUom;
    this.updatedContract.supplyMode = e.newData.supplyMode ?? e.oldData.supplyMode;
    this.updatedContract.awardYear = e.newData.awardYear ?? e.oldData.awardYear;
    this.updatedContract.term = e.newData.term ?? e.oldData.term;
    this.updatedContract.commenceYear = e.newData.commenceYear ?? e.oldData.commenceYear;
    this.updatedContract.expireYear = e.newData.expireYear ?? e.oldData.expireYear;
    this.updatedContract.annualRevenue = e.newData.annualRevenue ?? e.oldData.annualRevenue;
    this.updatedContract.notes = e.newData.notes ?? e.oldData.notes;
    this.updatedContract.contractId = e.oldData.contractId;
    this.updatedContract.siteId = e.newData.siteId ?? e.oldData.siteId;
    this.updatedContract.materialId = e.newData.materialId ?? e.oldData.materialId;

    this.contractService.saveContractDetails(this.updatedContract).subscribe(data => {
      if (data) {
        this.notificationService.alert("success", "Record saved successfully", null );
        this.isLoadPanelVisible = false;
        }
        e.cancel = false;
      },
        error => {
          this.notificationService.alert("error", "Error occured while saving the contract", error);
          this.isLoadPanelVisible = false;
          e.cancel = true;
        });
  }

  getSuppliers() {
    try {
      this.contractService.getSuppliers().subscribe(data => {
      if (data) {
        this.suppliers = data;
        this.suppliers.unshift('');
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the suppliers", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the suppliers", null);
      this.isLoadPanelVisible = false;
    }
  }

  getMaterials() {
    try {
      this.contractService.getMaterials().subscribe(data => {
      if (data) {
        this.materials = data;
        this.materials.unshift(new Material());
        this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the materials", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the materials", null);
      this.isLoadPanelVisible = false;
    }
  }
}
